import { render, staticRenderFns } from "./DunGou.vue?vue&type=template&id=4aa5a346&scoped=true"
import script from "./DunGou.vue?vue&type=script&lang=js"
export * from "./DunGou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5a346",
  null
  
)

export default component.exports